module.exports = __webpack_public_path__ + "img/gato.835d101f.svg";